import { ShareListItemFragment } from 'gqlTypes'

export const canRestoreShare = (
  share: Pick<ShareListItemFragment, 'userAccessLevel'>
) => share.userAccessLevel === 'EDIT'
